import React, { useState } from "react";
import "./Gallery.css"; // We'll style with this file

const images = [
 
  { src: "/imagesgallery/gallery11.jpeg", alt: "Gallery" },
  { src: "/imagesgallery/gallery12.jpeg", alt: "Gallery" },
  { src: "/imagesgallery/gallery13.jpeg", alt: "Gallery" },
  { src: "/imagesgallery/gallery14.jpeg", alt: "Gallery" },
  { src: "/imagesgallery/gallery15.jpeg", alt: "Gallery" },
  { src: "/imagesgallery/gallery16.jpeg", alt: "Gallery" },
  { src: "/imagesgallery/gallery17.jpeg", alt: "Gallery" },
  { src: "/imagesgallery/gallery18.jpeg", alt: "Gallery" },
  { src: "/imagesgallery/gallery19.jpeg", alt: "Gallery" },
  { src: "/imagesgallery/gallery20.jpeg", alt: "Gallery" },
  
  // Add more images gallery01
];

function Gallery() {
  const [selectedImg, setSelectedImg] = useState(null);

  return (
    <>
      <div className="gallery-grid">
        {images.map((img, index) => (
          <img
            key={index}
            src={img.src}
            alt={img.alt}
            onClick={() => setSelectedImg(img.src)}
            className="gallery-image"
          />
        ))}
      </div>

      {selectedImg && (
        <div className="lightbox" onClick={() => setSelectedImg(null)}>
          <img src={selectedImg} alt="Zoomed" className="lightbox-image" />
        </div>
      )}
    </>
  );
}

export default Gallery;
